import clsx from 'clsx';
import React from 'react';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css'

/**
 * This component contains sub components that are usefull for aboutPage page
 */

//  This component renders the images. It contains a zoom mechanism when we click at the image. 
const ZoomImage=({srcImg}) => 
    (
        <div style={{marginTop: '1rem'}} className={clsx("col-md-12")}>
            {/* Zoom mechanism  served by Zoom package  */}
            <Zoom>
                <img id='ZoomImageId' src ={srcImg} alt='zoom' className={clsx('img-responsive')}/>
            </Zoom>         
        </div>
    )

/** 
 *  This component renders the button that is placed at the bottom of the aboutPage page. 
 *  When we click on topButton the view of the page is transferred at the top of the page
 * */
const TopButton = ({myRef}) => {
    
    //  Function that is executed when we click on button and transferrs the view of our page page at the top of the page
    const executeScroll = () => myRef.current.scrollIntoView() 

    return(
        <p><button type='button' id='topButtonId' className='linkToButton' style={{color: '#0c4d82'}} href='#' onClick={executeScroll}>Back to top</button></p>   
    )
}

/**
 * This component renders a title with a corresponding image and an empty line.
 */
const TitleImage = ({title, srcImg}) => (
        <>
            <p id='titleId'>{title}</p>
            <ZoomImage srcImg={srcImg} />
            <br />
        </>    
)
    

export {
    ZoomImage,
    TopButton,
    TitleImage
}